import { isSafeUrl } from '@atlaskit/adf-schema/url';
export var validatorFnMap = {
  // eslint-disable-next-line @atlaskit/editor/no-re-export
  safeUrl: isSafeUrl
};